import { TfiEmail } from 'react-icons/tfi'
import { TbPhoneCall } from 'react-icons/tb'
import { FooterContainer, ContactInformation, MapFrameContainer, ContactItemWrapper } from "./styles"
import ContactForm from 'components/Form/ContactForm'
import { useTranslation } from 'gatsby-plugin-react-i18next'

const Footer = () => {
  const { t } = useTranslation()

  return (
    <FooterContainer>
      <ContactInformation>
        <h3>{t('connectWithUs')}</h3>
        <p>
          <ContactItemWrapper>
            <TbPhoneCall style={{ verticalAlign: 'middle' }} />
            {' '}
            <a href="tel:+359894328043">+359 894 32 80 43</a>
          </ContactItemWrapper>
          <ContactItemWrapper>
            <TbPhoneCall style={{ verticalAlign: 'middle' }} />
            {' '}
            <a href="tel:+359899863288">+359 899 86 32 88</a>
          </ContactItemWrapper>
          <ContactItemWrapper>
            <TfiEmail style={{ verticalAlign: 'middle' }} />
            {' '}
            <a href="mailto:pricelessfriends@abv.bg">pricelessfriends@abv.bg</a>
          </ContactItemWrapper>
        </p>
        <ContactForm />
      </ContactInformation>
      <MapFrameContainer>
        <iframe
          title='Google Maps'
          style={{ border: 0 }}
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d5819.100837115056!2d27.4410986!3d43.1769604!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40a5bb3c34f3d07b%3A0xe159ecfa26dec3f5!2z0JLQtdGC0LXRgNC40L3QsNGA0L3QsCDQsNC_0YLQtdC60LAg0Lgg0LrQsNCx0LjQvdC10YIgIiDQn9GA0L7QvNC10LQi!5e0!3m2!1sen!2sbg!4v1678521593900!5m2!1sen!2sbg"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"></iframe>
      </MapFrameContainer>
    </FooterContainer>
  )
}

export default Footer
